<script setup lang="ts">
import { useLegalAccountDataState } from '../../../../utilities/account/useAccountDataLegal'

import { navigationItemsLegal } from '../../../../utilities/account/useAccountNavigationLegal'
import AccountPanelIcon from '../../AccountPanelIcon.vue'
const { legalProfile } = useLegalAccountDataState()

const emit = defineEmits(['edit'])
function edit() {
    emit('edit')
}
</script>

<template>
    <div class="flex flex-wrap pb-6">
        <div class="flex w-full space-x-6 border-b border-gray-200 bg-gray-50 px-4 py-2 sm:px-8">
            <AccountPanelIcon
                class="w-5"
                page="Company Data"
                :navigation-items="navigationItemsLegal"></AccountPanelIcon>
            <span class="flex-1 text-sm font-bold text-gray-700">
                {{ $t('account_settings_legal.company_data') }}
            </span>
            <button class="text-sm hover:text-gray-600" @click="edit">
                {{ $t('account_settings.edit') }}
            </button>
        </div>

        <div class="flex-1 pl-4 sm:pl-8">
            <dl class="grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2">
                <div class="flex w-full items-center space-x-3 sm:col-span-2"></div>
                <div class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">
                        {{ $t('legal_account.company_name') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                        {{ legalProfile.company_name }}
                    </dd>
                </div>
                <div class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">
                        {{ $t('legal_account.registration_number') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                        {{ legalProfile.registration_number }}
                    </dd>
                </div>
                <div class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">
                        {{ $t('legal_account.description') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                        {{ legalProfile.description }}
                    </dd>
                </div>
            </dl>
        </div>
    </div>
</template>
